module.exports = "pegasus_template/assets/preview-10.png";